import React, { useState, memo } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito tener disciplina o fuerza de voluntad para que esto funcione?',
  a: 'No. El sistema está diseñado específicamente para funcionar sin fuerza de voluntad. El Tomo 2 resetea tu química cerebral y el Tomo 3 rediseña tu entorno para que el enfoque sea el camino de menor resistencia, no una batalla diaria.'
}, {
  q: '¿En qué formato recibo el material?',
  a: '100% PDF descargable. Accedés de forma inmediata después del pago y podés consultarlo desde el celular, tablet o computadora en cualquier momento y lugar.'
}, {
  q: '¿Funciona si trabajo desde casa y tengo muchas distracciones?',
  a: 'Sí. El Tomo 3 está dedicado exactamente a ese problema. Rediseñás tu entorno físico y digital para que las distracciones sean difíciles y el foco sea fácil, sin importar dónde trabajes.'
}, {
  q: '¿Cuánto tiempo tengo acceso al material?',
  a: 'Acceso de por vida. Una vez que lo descargás, es tuyo para siempre. Sin suscripciones, sin fechas de vencimiento.'
}, {
  q: '¿En cuánto tiempo veo resultados reales?',
  a: 'Con el Bono 1 (Kit de Enfoque Inmediato) podés hacer tu primer bloque de trabajo profundo hoy mismo. En 7 días notás la diferencia en tu claridad mental. En 30 días el sistema está instalado y funcionando.'
}, {
  q: '¿Qué pasa si tengo un Día Cero y rompo el sistema?',
  a: 'El Tomo 5 incluye el Protocolo de Día Cero exactamente para esto. Un día malo no es el fin del sistema, es parte de él. El protocolo te reinicia en menos de 10 minutos sin culpa y sin perder el progreso acumulado.'
}, {
  q: '¿Qué pasa si no me sirve?',
  a: 'Tenés 30 días de garantía total. Si por cualquier motivo no estás conforme, te devolvemos el 100% de tu inversión sin preguntas. Escribinos a construyeprogresoo@gmail.com.'
}, {
  q: '¿Tiene soporte ante dudas?',
  a: 'Sí. El equipo de ConstruyeProgreso™ está disponible en construyeprogresoo@gmail.com para responder consultas sobre el contenido del Megapack.'
}];
const FAQItem = memo(function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-xl overflow-hidden bg-white shadow-sm" data-id="element-40">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-5 py-4 text-left flex justify-between items-center focus:outline-none hover:bg-gray-50 transition-colors" data-id="element-41">
        <span className="font-bold text-gray-900 text-[14px] md:text-base pr-4" data-id="element-42">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-yellow-500 transition-transform duration-200 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-43" />
      </button>
      {isOpen && <div className="px-5 pb-4 text-gray-600 text-[13px] md:text-sm leading-relaxed border-t border-gray-200 pt-3 bg-gray-50/50" data-id="element-44">
          {answer}
        </div>}
    </div>;
});
export const FAQSection = memo(function FAQSection() {
  return <section className="py-16 px-4 bg-gray-50 border-t border-gray-200" data-id="element-45">
      <div className="max-w-2xl mx-auto" data-id="element-46">
        {/* Header */}
        <div className="text-center mb-10" data-id="element-47">
          <div className="inline-block bg-yellow-50 border border-yellow-200 text-yellow-600 text-[11px] font-black uppercase tracking-widest px-4 py-1.5 rounded-full mb-4" data-id="element-48">
            💬 Preguntas frecuentes
          </div>
          <h2 className="text-[26px] md:text-4xl font-black text-gray-900 leading-tight" data-id="element-49">
            Preguntas Frecuentes sobre el{' '}
            <span className="text-yellow-500" data-id="element-50">Megapack Domina Tu Mente</span>
          </h2>
        </div>

        {/* FAQs */}
        <div className="space-y-3" data-id="element-51">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-52" />)}
        </div>
      </div>
    </section>;
});